"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const executeProcessesFactory_1 = __importDefault(require("../applicationFunctionality/executeProcessesFactory"));
const createRunnableProcess_1 = __importDefault(require("./createRunnableProcess"));
const entryVarEvaluateCallback = ({ store, entryVar, processor, functionsDefinitions, controlCallerId, eventOutputs, itemContext, }) => {
    const callable = ({ lastFunctionsOutputs, extraFunctionDefinitions, }) => {
        const processIds = entryVar.process || [];
        const processes = [];
        processIds.forEach((processId) => {
            const process = (0, createRunnableProcess_1.default)({
                processor,
                functionId: processId,
                store,
                extraFunctionDefinitions,
                functionsDefinitions,
            });
            if (process) {
                processes.push(process);
            }
        });
        (0, executeProcessesFactory_1.default)({
            store,
            processor,
            controlCallerId,
            eventOutputs,
            itemContext,
            lastFunctionsOutputs,
        })(undefined, processes);
    };
    return callable;
};
exports.default = entryVarEvaluateCallback;
